import React from "react";
import "./Features.css";

const Features = () => {
  const data = [
    {
      heading: "More Opportunities",
      darkText: "Become a part  ",
      simpleText:
        "of a unified platform for premium digital learning — get access to top global online universities and skill-based programs from one place.",
      img: "/assets/images/home/features/img1.png",
    },
    {
      heading: "Zero Pressure, Zero Stress",
      darkText: "No aggressive targets. ",
      simpleText:
        " Your earnings remain consistent irrespective of monthly enrollments. ",
      img: "/assets/images/home/features/img2.png",
    },
    {
      heading: "Reliable & Growing Earnings",
      darkText: "Earn guaranteed ",
      simpleText: "monthly two-time payouts with an additional tier-based incentive model as you exceed performance milestones. ",
      img: "/assets/images/home/features/img3.png",
    },
    {
      heading: "Tools to Help You Win",
      darkText: "Get everything you need for success",
      simpleText:
        "  — expert training, marketing collateral, partner case studies, CRM access, MIS dashboards & business analytics.",
      img: "/assets/images/home/features/img4.png",
    },
    {
      heading: "Seamless Education Financing for Students",
      darkText: "Flexible loan and instalment ",
      simpleText:
        " options so students never miss enrollment due to financial constraints. ",
      img: "/assets/images/home/features/img5.png",
    },
    {
      heading: "Unmatched Partner Support",
      darkText: "Dedicated Relationship Managers, ",
      simpleText:
        " fast resolution processes, and access to 50+ in-demand programs across multiple career streams.",
      img: "/assets/images/home/features/img6.png",
    },
  ];

  return (
    <section className="Features">
      <div className="container">
        <div className="titlediv">
           <h3><b>Benefits</b> of Partnering with Profcyma</h3>
          </div>
        <div className="all_cards_holder">
          <div className="row">
            {data?.map((item) => {
              return (
                <div className="col-lg-4 col-sm-6 mb-4">
                  <div className="feature_card">
                    <div className="left_text_holder">
                      <p className="heading_text">{item?.heading}</p>

                      <p className="simple_text">
                        <b>{item?.darkText}</b>
                        {item?.simpleText}
                      </p>
                    </div>
                    <div className="right_img_div">
                      <div className="img_holder">
                        <img
                          src={process.env.PUBLIC_URL + item?.img}
                          className="right_img"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
